import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { JZCallbackPageComponent } from './jz-callback-page.component';
import { JZLoginPageComponent } from './jz-login-page.component';

const routes: Routes = [
  {
    path: 'auth',
    children: [
      { path: 'login', component: JZLoginPageComponent },
      { path: 'callback', component: JZCallbackPageComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JZAuthRoutingModule {}
